import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import {
  DateFormWidget,
  FileUpload,
  FormButtons,
  FormRow,
  LocationMapField,
} from '../controls';

function buildDefaultValues(attraction) {
  return {
    attractionName: attraction.attractionName || '',
    attractionDescription: attraction.attractionDescription || '',
  };
}

export function AttractionForm({
  attraction,
  onDateChange,
  handleSave,
  handleRemove,
  onLocationChange,
  onLocationNameChange,
  onFileUpload,
  onFileDelete,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(attraction),
    mode: 'onSubmit',
  });

  const attractionId = attraction?.attractionId;

  useEffect(() => {
    reset(buildDefaultValues(attraction));
  }, [attractionId, reset]);

  const { startTime, startTimeMS, endTime, endTimeMS } = attraction;
  const dates = [{ startTime, startTimeMS, endTime, endTimeMS }];

  const fileList = [];

  if (attraction?.photoURL) {
    fileList.push({
      uid: '-1',
      name: attraction.attractionPhoto,
      url: attraction.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <div className="flex">
        <div className="w-3/4 p-4">
          <FormRow
            label="Attraction Name"
            error={errors.attractionName?.message}
          >
            <input
              type="text"
              placeholder="Name"
              {...register('attractionName', {
                required: 'Attraction name is required',
              })}
            />
          </FormRow>
          <DateFormWidget
            label="Dates & Times"
            dates={dates}
            handleDateChange={onDateChange}
          />
        </div>
        <div className="w-1/4 p-4">
          <div className="w-full">
            <FileUpload
              fileList={fileList}
              onFileUpload={onFileUpload}
              onFileDelete={onFileDelete}
            />
          </div>
        </div>
      </div>
      <FormRow>
        <LocationMapField
          location={attraction.location}
          locationName={attraction.location?.locationName}
          onLocationChange={onLocationChange}
          onLocationNameChange={onLocationNameChange}
        />
      </FormRow>
      <FormRow label="Description">
        <textarea
          placeholder="Attraction Description..."
          {...register('attractionDescription')}
        />
      </FormRow>
      <FormButtons
        showDelete={attraction.attractionId}
        label="Attraction"
        onDelete={handleRemove}
      />
    </form>
  );
}
